import './modal-popup-share.scss';

/**
 * version    1.0
 * class      <type> (ModalPopupShare)
 * classdesc  Modal
 */
export class ModalPopupShare {}
